import { render } from "./UserMenu.vue?vue&type=template&id=6d334d45&ts=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/proprint/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__